import { AHText, Box, useSpaceSize, useTheme } from "arkh";
import { FormattedMessage } from "react-intl";
import { graphql, usePaginationFragment } from "react-relay";
import { TodoTimelineCreatedEvent, TodoTimelineItem } from "widgets";
import { TodoDetailTimeline_todo$key } from "./__generated__/TodoDetailTimeline_todo.graphql";
import { ScrollView, View } from "react-native";
import React from "react";

export const TodoDetailTimeline = React.memo(TodoDetailTimelineC);
function TodoDetailTimelineC(props: {
  todo: TodoDetailTimeline_todo$key;
  isTouchMode: boolean;
}) {
  const { data } = usePaginationFragment(
    graphql`
      fragment TodoDetailTimeline_todo on Todo
      @refetchable(queryName: "TodoDetailTimeline_todoRefetchQuery")
      @argumentDefinitions(
        last: { type: "Int", defaultValue: 30 }
        before: { type: "String", defaultValue: null }
      ) {
        ...TodoTimelineUpdateEventCreated_todo
        createdByActor {
          __typename
        }
        timeline(last: $last, before: $before)
          @connection(key: "TodoDetailTimeline__timeline") {
          __id
          edges {
            node {
              ...TodoTimeline_item
            }
          }
        }
      }
    `,
    props.todo
  );

  const theme = useTheme();
  const backgroundGradient = `
          linear-gradient(to bottom,
          ${theme["surface-background-light"]} 70%,
          transparent)`;
  const headerHeight = useSpaceSize("large");
  if (!data.createdByActor && data.timeline.edges.length === 0) {
    return null;
  }

  if (props.isTouchMode) {
    return (
      <ScrollView>
        <Box spaceTop="medium" spaceHorizontal="small">
          <Title />
        </Box>
        <Box gap="small" spaceVertical="small">
          <TodoTimelineCreatedEvent todo={data} />
          {data.timeline.edges.map((edge, i) =>
            edge.node ? (
              <TodoTimelineItem key={i + ""} item={edge.node} />
            ) : null
          )}
        </Box>
      </ScrollView>
    );
  }

  return (
    <Box spaceTop="medium">
      <Box spaceVertical="none" gap="small" style={{ flex: 1 }}>
        <View
          style={{
            flex: 1,
            justifyContent: "flex-end",
            overflow: "hidden",
          }}
        >
          <Box
            gap="small"
            style={{ minHeight: "100%" }}
            insets={{
              top: headerHeight,
            }}
          >
            <TodoTimelineCreatedEvent todo={data} />
            {data.timeline.edges.map((edge, i) =>
              edge.node ? (
                <TodoTimelineItem key={i + ""} item={edge.node} />
              ) : null
            )}
          </Box>
        </View>
        <Box
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            height: headerHeight,
            justifyContent: "center",
            ...(backgroundGradient ? { background: backgroundGradient } : {}),
          }}
          spaceHorizontal="small"
        >
          <Title />
        </Box>
      </Box>
    </Box>
  );
}

function Title() {
  return (
    <AHText type="subtitle" color="text-secondary">
      <FormattedMessage
        description="Todo Edit Timeline Title"
        defaultMessage="Activity"
      />
    </AHText>
  );
}
